<template>
  <div class="wrapp_content"
       style="width: 100%; height: 500px;">
    <!--添加设备 -->
    <div class="">

      <input id="ID"
             name="ID"
             v-model="ruleForm.id"
             type="hidden" />
      <div id="viewpoint-modal-main"
           class="select-modal-div"
           style="display: block;">
        <el-form :model="ruleForm"
                 :rules="rules"
                 ref="ruleForm"
                 label-width="100px"
                 class="ruleFormcss">
          <el-form-item prop="DeviceName"
                        label="设备名称">
            <el-input type="text"
                      id="DeviceName"
                      name="DeviceName"
                      v-model="ruleForm.DeviceName"
                      class="input-text"
                      value=""
                      style="width:80%;">
            </el-input>
          </el-form-item>
          <el-form-item label="指标项：">
            <label style="text-align: left;">电压，电流</label>
          </el-form-item>

          <el-form-item prop="TagWidth"
                        label="宽度：">
            <el-input type="text"
                      id="TagWidth"
                      name="TagWidth"
                      v-model.number="ruleForm.TagWidth"
                      class="input-text"
                      value="100"
                      style="width:80%;">
            </el-input>
          </el-form-item>
          <el-form-item prop="TagHeight"
                        label="高度：">
            <el-input type="text"
                      id="TagHeight"
                      name="TagHeight"
                      v-model.number="ruleForm.TagHeight"
                      class="input-text"
                      value="60"
                      style="width:80%;">
            </el-input>
          </el-form-item>
          <el-form-item prop="TagStyle"
                        label="风格：">

            <el-radio-group v-model="ruleForm.TagStyle">
              <el-radio label="0">方 </el-radio><label for="square">
                <!-- <span class="square"></span> -->
              </label>
              <el-radio label="1">圆</el-radio><label for="rond">
                <!-- <span class="round"></span> -->
              </label>
            </el-radio-group>
          </el-form-item>

          <el-form-item>
            <el-button type="primary"
                       class="login-button"
                       @click="saveDevice">保存</el-button>
            <!-- <el-button type="info" class="cancel-but">关闭</el-button> -->
          </el-form-item>

        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from '@/services/API-services'
export default {
  name: 'editeq',
  data() {
    return {
      ruleForm: {
        id: 0,
        TagHeight: '',
        DeviceName: '',
        TagWidth: '',
        TagStyle: ''
      },
      rules: {
        DeviceName: [{
          required: true,
          message: '请输入设备名',
          trigger: 'blur'
        },
        {
          min: 1,
          max: 18,
          message: '长度在 1 到 18 个字符',
          trigger: 'blur'
        }
        ],
        TagStyle: [{
          required: true,
          message: '请选择',
          trigger: 'blur'
        }],
        TagWidth: [{
          required: true,
          message: '请输宽度',
          trigger: 'blur'
        },
        {
          type: 'integer',
          message: '必须为数字值',
          trigger: 'blur'
        }

        ],
        TagHeight: [{
          required: true,
          message: '请输高度',
          trigger: 'blur'
        },
        {
          type: 'integer',
          message: '必须为数字值',
          trigger: 'blur'
        }

        ]
      }
    }
  },
  methods: {
    saveDevice() {
      let isChecked = true
      this.$refs['ruleForm'].validate((valid) => {
        isChecked = valid
      })
      if (!isChecked) {
        return
      }
      ApiService.tree.add({
        id: 0,
        DeviceName: this.ruleForm.DeviceName,
        DeviceItem: '',
        TagWidth: this.ruleForm.TagWidth,
        TagHeight: this.ruleForm.TagHeight,
        TagStyle: this.ruleForm.TagStyle,
        DevicePosition: '',
        CameraPos: '',
        mileageID: window.R_config.modelId,
        ChildID: '10'
      }).then((res) => {
        console.log(res.data)
        this.$refs['ruleForm'].resetFields()
      })
    }
  }
}
</script>

<style scoped>
.ruleFormcss {
  margin-top: 0.5rem;
}
</style>


// WEBPACK FOOTER //
// src/components/equipment/editeq.vue